import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from '@/App'
import '@/index.css'
import { Toaster } from '@quest-lock/ui/sonner'
import { PostHogProvider } from 'posthog-js/react'
import { queryClient } from './config'
import { QueryClientProvider } from '@tanstack/react-query'

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(registrations => {
    for (const registration of registrations) {
      registration.unregister()
    }
  })
}

const container = document.getElementById('root') as HTMLDivElement
const root = createRoot(container)
root.render(
  <StrictMode>
    <PostHogProvider
      apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY}
      options={{
        api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
        defaults: '2025-05-24',
        capture_exceptions: true,
        debug: import.meta.env.MODE === 'development',
        persistence: 'memory'
      }}
    >
      <QueryClientProvider client={queryClient}>
        <App />
        <Toaster />
      </QueryClientProvider>
    </PostHogProvider>
  </StrictMode>
)
